export const CLOUDPAT_DIAGNOSTIC_REPORT_SYSTEM = 'https://cloudpat.itamar-medical.com/diagnostic-report-id';
export const CLOUDPAT_HSAT_SERVICE_REQUEST_SYSTEM = 'https://polarissleep.com/service-request-type';
export const COMPOSITION_TYPE_SYSTEM = 'http://polarissleep.com/composition-types';
export const POLARIS_INSURANCE_ELIGIBILITY_STATUS_TAG_SYSTEM =
  'http://polarissleep.com/status-tags/insurance-eligibility';
